<template>
    <div class="col-12 col-md-6">
        <div class="card card-profile card-plain">
            <div class="row">

                <div class="col-12 col-md-5 d-flex flex-row align-items-center" v-if="hasCoverImage">
                    <router-link :to="'/product/' + gtin" class="m-auto">
                    <div class="card-header card-header-image">
                            <img class="img"
                                 :src="mediumCover"/>
                    </div>
                    </router-link>
                </div>

                <div class="col-12 col-md-7">
                    <div class="card-body row">
                        <h4 class="card-title col-12 text-center text-lg-left">
                            <router-link :to="'/product/' + gtin">
                                {{ article.title }}
                            </router-link>
                        </h4>
                        <p class="card-description col-12 col-sm-6 col-md-12 text-center text-sm-right text-md-left">
                            <template v-if="article.physical_release_date">
                                {{ $t('product.release_date') }}: <b>{{dateFormat(article.physical_release_date)}}</b><br>
                            </template>
                            {{ $t('product.genre') }}: <b>{{article.genre.name}}</b><br>
                            {{ $t('product.configuration') }}: <b>{{article.configuration.name}} ({{article.set_total}})</b><br>
                        </p>
                        <div class="d-flex flex-column align-items-center align-items-lg-start col-12 col-sm-6 col-md-12">
                            <div class="btn btn-just-icon btn-github btn-round"
                                 data-toggle="tooltip" data-placement="top"
                                 :title="$t('product.sample_exists')" v-if="hasStreaming">
                                <i class="material-icons">headset</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import isString from 'lodash-es/isString'

export default {
  name: 'ListProductComponent',
  props: ['id', 'article'],
  computed: {
    gtin () {
      return this.article.gtin
    },
    cover () {
      try {
        if (isString(this.$props.article.artworks.artwork[0].url)) {
          return this.$props.article.artworks.artwork[0].url
        }
      } catch (err) {
        return null
      }
    },
    mediumCover: function () {
      if (isString(this.cover)) {
        return this.cover.replace('0080px', '0300px')
      }
      return null
    },
    hasCoverImage () {
      return this.article.has_cover
    },
    hasStreaming () {
      return this.article.has_tracks === true && this.article.has_sound
    }
  },
  methods: {
    dateFormat (date) {
      return moment(date).format('DD.MM.YYYY')
    }
  }
}
</script>

<style scoped>

</style>
